
export class ProduktLangdfordelningDTO   {

    id: number;
    andel: number;
    typ: string;
    langdBotten: number;

    constructor() {
        this.id = undefined;
        this.andel = undefined;
        this.typ = undefined;
        this.langdBotten = undefined;
    }
}
